(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('click', function(event) {
  var btn = event.target.closest('[data-search-open]');
  if (!btn) return;
  event.preventDefault();

  document.dispatchEvent(new CustomEvent('predictive-search:open', {
    detail: { context: 'header' },
    bubbles: true
  }));

  var container = document.querySelector('.site-header__search-container');
  if (container) container.classList.add('is-active');
  document.documentElement.classList.add('js-drawer-open', 'js-drawer-open--search');
});

document.addEventListener('predictive-search:close-all', function() {
  var container = document.querySelector('.site-header__search-container');
  if (container) container.classList.remove('is-active');
  document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open--search');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  class HeroCarousel {
    constructor(el) {
      this.el = el;
      this.track = el.querySelector(".hero-carousel__track");
      this.slides = el.querySelectorAll(".hero-carousel__slide");
      this.prevBtn = el.querySelector("[data-action=prev]");
      this.nextBtn = el.querySelector("[data-action=next]");
      this.dots = el.querySelectorAll("[data-action=goto]");
      this.current = 0;
      this.total = this.slides.length;
      this.autoplay = el.dataset.autoplay === "true";
      this.autoplaySpeed = parseInt(el.dataset.autoplaySpeed, 10) || 5000;
      this.timer = null;
      this.touchStartX = 0;
      if (this.total > 1) this.init();
    }
    init() {
      if (this.prevBtn) this.prevBtn.addEventListener("click", () => this.go(this.current - 1));
      if (this.nextBtn) this.nextBtn.addEventListener("click", () => this.go(this.current + 1));
      this.dots.forEach((dot) => {
        dot.addEventListener("click", () => this.go(parseInt(dot.dataset.index, 10)));
      });
      this.el.addEventListener("keydown", (e) => {
        if (e.key === "ArrowLeft") { e.preventDefault(); this.go(this.current - 1); }
        if (e.key === "ArrowRight") { e.preventDefault(); this.go(this.current + 1); }
      });
      this.track.addEventListener("touchstart", (e) => { this.touchStartX = e.touches[0].clientX; }, { passive: true });
      this.track.addEventListener("touchend", (e) => {
        const delta = this.touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(delta) > 50) this.go(delta > 0 ? this.current + 1 : this.current - 1);
      }, { passive: true });
      this.el.addEventListener("mouseenter", () => this.stopAutoplay());
      this.el.addEventListener("mouseleave", () => { if (this.autoplay) this.startAutoplay(); });
      if (this.autoplay) this.startAutoplay();
    }
    go(index) {
      this.current = ((index % this.total) + this.total) % this.total;
      this.track.style.transform = "translateX(-" + (this.current * 100) + "%)";
      this.slides.forEach((slide, i) => {
        const active = i === this.current;
        slide.classList.toggle("is-active", active);
        slide.setAttribute("aria-hidden", String(!active));
      });
      this.dots.forEach((dot, i) => {
        const active = i === this.current;
        dot.classList.toggle("is-active", active);
        dot.setAttribute("aria-selected", String(active));
      });
    }
    startAutoplay() { this.stopAutoplay(); this.timer = setInterval(() => this.go(this.current + 1), this.autoplaySpeed); }
    stopAutoplay() { clearInterval(this.timer); this.timer = null; }
  }
  document.querySelectorAll(".hero-carousel").forEach((el) => new HeroCarousel(el));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      var signal = this.abortController.signal;

      this.initCarousel(signal);

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
          this._clearAutoPlay();
          this.initCarousel(signal);
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        var btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        var popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this._carouselObserver?.disconnect();
      this._clearAutoPlay();
    }

    initCarousel(signal) {
      var track = this.querySelector('.kit-shoppable-hero__track');
      if (!track) return;

      var slides = Array.from(track.querySelectorAll('.kit-shoppable-hero__slide'));
      if (slides.length <= 1) return;

      var prevBtn = this.querySelector('.kit-shoppable-hero__prev');
      var nextBtn = this.querySelector('.kit-shoppable-hero__next');
      var dots = Array.from(this.querySelectorAll('.kit-shoppable-hero__dot'));
      var counter = this.querySelector('.kit-shoppable-hero__counter');
      var wrap = this.querySelector('.kit-shoppable-hero__carousel-wrap');

      var currentIndex = 0;
      var total = slides.length;
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoplay = this.dataset.autoplay === 'true' && !prefersReducedMotion;
      var autoplaySpeed = (parseInt(this.dataset.autoplaySpeed) || 5) * 1000;
      var isDragging = false;
      var startX = 0;

      var goTo = (index) => {
        currentIndex = ((index % total) + total) % total;
        track.scrollTo({
          left: slides[currentIndex].offsetLeft,
          behavior: prefersReducedMotion ? 'auto' : 'smooth'
        });
        this._syncCarousel(currentIndex, slides, dots, counter, prevBtn, nextBtn, total);
      };

      var startAutoPlay = () => {
        this._clearAutoPlay();
        this._autoPlayTimer = setInterval(() => goTo(currentIndex + 1), autoplaySpeed);
      };

      this._syncCarousel(0, slides, dots, counter, prevBtn, nextBtn, total);

      if (prevBtn) prevBtn.addEventListener('click', () => goTo(currentIndex - 1), { signal });
      if (nextBtn) nextBtn.addEventListener('click', () => goTo(currentIndex + 1), { signal });

      dots.forEach((dot, i) => {
        dot.addEventListener('click', () => goTo(i), { signal });
      });

      track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(currentIndex - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(currentIndex + 1); }
      }, { signal });

      this._carouselObserver?.disconnect();
      this._carouselObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            var idx = slides.indexOf(entry.target);
            if (idx !== -1 && idx !== currentIndex) {
              currentIndex = idx;
              this._syncCarousel(currentIndex, slides, dots, counter, prevBtn, nextBtn, total);
            }
          }
        });
      }, { root: track, threshold: 0.6 });

      slides.forEach((slide) => this._carouselObserver.observe(slide));

      track.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        startX = e.clientX;
        isDragging = true;
        track.setPointerCapture(e.pointerId);
        this._clearAutoPlay();
      }, { signal });

      track.addEventListener('pointermove', (e) => {
        if (!isDragging) return;
        e.preventDefault();
      }, { signal, passive: false });

      track.addEventListener('pointerup', (e) => {
        if (!isDragging) return;
        isDragging = false;
        var delta = startX - e.clientX;
        if (Math.abs(delta) > 50) {
          goTo(delta > 0 ? currentIndex + 1 : currentIndex - 1);
        }
        if (autoplay) startAutoPlay();
      }, { signal });

      if (autoplay && wrap) {
        startAutoPlay();
        wrap.addEventListener('mouseenter', () => this._clearAutoPlay(), { signal });
        wrap.addEventListener('mouseleave', startAutoPlay, { signal });
        wrap.addEventListener('focusin', () => this._clearAutoPlay(), { signal });
        wrap.addEventListener('focusout', startAutoPlay, { signal });
      }
    }

    _syncCarousel(index, slides, dots, counter, prevBtn, nextBtn, total) {
      dots.forEach((dot, i) => {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
        dot.tabIndex = active ? 0 : -1;
      });

      if (counter) counter.textContent = (index + 1) + ' / ' + total;
      if (prevBtn) prevBtn.hidden = index === 0;
      if (nextBtn) nextBtn.hidden = index === total - 1;
    }

    _clearAutoPlay() {
      if (this._autoPlayTimer) {
        clearInterval(this._autoPlayTimer);
        this._autoPlayTimer = null;
      }
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          var popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
